module.exports = __webpack_public_path__ + "img/navber_bg.49a7fd32.jpg";